import {
  FETCH_STORIES,
  FETCH_SELECTED_STORY,
  FETCH_MOMENTS,
  FETCH_STORY,
  FETCH_ACCOUNT_SETTINGS,
  FETCH_STRIPE_SETTINGS,
  FETCH_PREMIUM_STORIES,
  OPEN_CART_STORY,
  SET_DEEPLINK_STORY_ID,
  RE_KNOCKOUT_MOMENT,
  GET_MARKETING_BY_JOB,
  SHOW_MARKETING,
} from 'shared/actions/types';

import messages from 'shared/messages/messages';

import {
  API_BASE_URL,
  MOMENT_PREVIEW_URL,
  MOMENT_PREVIEW_URL_SMALL,
  MOMENT_THUMB_URL,
  MOMENT_THUMB_URL_LARGE,
  MOMENT_PRINT_URL
} from 'shared/utils/Constants';

// import { Braze } from 'shared/services/Braze';
import StoryService from 'shared/services/StoryService';
import { print, reduce } from 'shared/utils/Helpers';
import { v4 as uuidv4 } from 'uuid';

let storyService = new StoryService();

export const getMarketingByJobId = (jobId) => async dispatch => {
  let marketing = await storyService.getMarketingByJobId(jobId);
  dispatch({
    type: GET_MARKETING_BY_JOB,
    payload: marketing
  });
  return Promise.resolve(marketing);
}

export const showMarketing = visible => dispatch => {
  dispatch({
    type: SHOW_MARKETING,
    payload: visible
  });
}

export const loadStories = state => {
  return Object.values(state.storyReducer.stories.byId)
    .filter(story => { return story.purchased_count > 0 })
    .sort((a, b) => (b.id - a.id));
}

export const loadPremiumStories = state => {
  return Object.values(state.storyReducer.stories.byId)
    .filter(story => { return story.premium_count > 0 })
    .sort((a, b) => (b.id - a.id));
}

export const fetchStories = () => dispatch => {
  // By setting the "merging" param true in request, one representative story will be pulled
  // within a club med family
  let mergeFamily = true;
  return storyService.getStories(mergeFamily)
    .then(stories => {
      // filter out story invites (API returns stories the user isn't on)
      stories = stories.filter(s => !s.invited);

      stories.forEach(s => {
        if (s.cover_moment_id) {
          s.cover_moment_thumb = s.cover_moment_thumb || MOMENT_PREVIEW_URL_SMALL(s.cover_moment_id);
          s.cover_moment_url = s.cover_moment_url || MOMENT_PREVIEW_URL(s.cover_moment_id);
        }
      });

      // get flags and links for most recent story, assumed here to be the first one.
      let hasPremium = false;
      let hasNonPremium = false;
      let premiumLink = null;
      let nonPremiumLink = null;
      if (stories.length) {
        let story = stories[0];

        hasPremium = !!story.premium_count;
        hasNonPremium = !!story.moment_count && (!story.premium_count || (story.premium_count < story.moment_count));
        premiumLink = story.premium_link;
        nonPremiumLink = story.non_premium_link;
      }

      dispatch({
        type: FETCH_STORIES,
        payload: stories
      });

      // let u = Braze.getUser();
      // u.setCustomUserAttribute('Story.HasPremiumMoments', hasPremium);
      // u.setCustomUserAttribute('Story.HasNonPremiumMoments', hasNonPremium);
      // u.setCustomUserAttribute('Story.PremiumLink', premiumLink);
      // u.setCustomUserAttribute('Story.NonPremiumLink', hasNonPremium);

      return Promise.resolve(stories);
    });
}

export const createStory = storyData => dispatch => {
  return storyService.createStory(storyData)
    .then(story => {
      dispatch({
        type: FETCH_STORIES,
        payload: story
      });

      return Promise.resolve(story);
    });
}

export const updateStory = (id, params) => dispatch => {
  return storyService.updateStory(id, params)
    .then(story => {
      dispatch({
        type: FETCH_STORIES,
        payload: story
      });

      return Promise.resolve(story);
    });
}

export const selectStory = storyId => dispatch => {
  dispatch({
    type: FETCH_SELECTED_STORY,
    payload: storyId
  });
}

export const downloadStory = storyId => dispatch => {
  return storyService.downloadStory(storyId);
}

export const fetchStoryMoments = (storyId, page = 1, perPage = 50, opts = {}) => dispatch => {
  return storyService.getStoryMoments(storyId, page, perPage, opts)
    .then(moments => {
      moments.forEach(moment => {
        moment.preview_url ||= MOMENT_PREVIEW_URL(moment.id);
        moment.preview_url_small ||= MOMENT_PREVIEW_URL_SMALL(moment.id);
        moment.thumb_url ||= MOMENT_THUMB_URL(moment.id);
        moment.thumb_url_large ||= MOMENT_THUMB_URL_LARGE(moment.id);
        moment.print_url ||= MOMENT_PRINT_URL(moment.id);
      });

      moments = moments.sort((a, b) => a.position < b.position ? -1 : 1);

      //  return ensureMomentDimensions(moments);
      //})
      //.then(moments => {
      dispatch({
        type: FETCH_MOMENTS,
        payload: { storyId, moments }
      });

      return Promise.resolve(moments);
    })
}

export const addStoryMoments = (storyId, moments) => dispatch => {
  dispatch({
    type: FETCH_MOMENTS,
    payload: { storyId, moments }
  });

  return Promise.resolve(moments);
}

export const fetchAccountSettings = (storyId, moment) => dispatch => {
  return storyService.getAccountSettings(storyId)
    .then(settings => {
      settings.print_store_url = settings.store_url;

      if (settings.append_store_moment && moment) {
        settings.print_store_url += moment.id;
      }

      dispatch({
        type: FETCH_ACCOUNT_SETTINGS,
        payload: { storyId, settings }
      });

      return Promise.resolve(settings);
    });
}

export const fetchStripeSettings = (storyId) => dispatch => {
  return storyService.getCheckoutSettings(storyId)
    .then(settings => {

      dispatch({
        type: FETCH_STRIPE_SETTINGS,
        payload: { storyId, settings }
      });

      return Promise.resolve(settings);
    });
}

export const updateStoryMoments = (storyId, moments) => dispatch => {
  dispatch({
    type: FETCH_MOMENTS,
    payload: { storyId, moments }
  });
}

export const openCartStory = (user, story) => dispatch => {
  dispatch({
    type: OPEN_CART_STORY,
    payload: { user, story }
  });
}

export const setDeeplinkStoryId = (storyId) => dispatch => {
  dispatch({
    type: SET_DEEPLINK_STORY_ID,
    payload: storyId
  });
}

export const uploadMoments = (storyId, files, setCover = false) => dispatch => {
  // this function returns a promise that'll resolve before the upload
  // completes, with temp moments in Redux to display the images while
  // uploading. The resolved value will be another promise that resolves
  // once the upload is complete.
  return new Promise(resolve => {
    let tempMoments = [];

    for (let file of files) {
      // this id becomes the moment hash.
      // it'll be used to swap temp moments in Redux
      // with their uploaded versions
      let id = uuidv4();

      // this will be the data URI to display the image
      // while it's being uploaded
      let url = URL.createObjectURL(file);

      file.hash = id;

      tempMoments.push({
        id,
        hash: id,
        url,
        preview_url: url,
        preview_url_small: url,
        thumb_url: url,
        thumb_url_large: url
      });
    }

    ensureMomentDimensions(tempMoments)
      .then(tempMoments => {
        let payload = {
          id: storyId,
          moments_count: tempMoments.length
        }

        if (setCover) {
          let coverMoment = tempMoments[0];

          payload.cover_moment = coverMoment;
          payload.cover_moment_id = coverMoment.id;
          payload.cover_moment_preview = coverMoment.preview_url;
          payload.cover_moment_thumb = coverMoment.preview_url;
          payload.cover_moment_url = coverMoment.preview_url;
        }

        dispatch({
          type: FETCH_STORY,
          payload: payload
        });

        dispatch({
          type: FETCH_MOMENTS,
          payload: { storyId, moments: tempMoments }
        });

        // resolve the main promise.
        // calling code will have the temp moments
        // and a promise that'll resolve once the upload completes
        resolve();

        for (let file of files) {
          for (let moment of tempMoments) {
            if (moment.id === file.hash) {
              file.width = moment.width;
              file.height = moment.height;
              break;
            }
          }
        }

        return storyService.createMoments(storyId, files)
      })
      .then(moments => {
        let promises = [];

        for (let moment of moments) {
          for (let file of files) {
            if (file.hash === moment.hash) {
              promises.push(uploadMoment(moment, file));
              break;
            }
          }
        }

        promises.push(storyService.addMomentsToStory(storyId, moments.map(m => m.id)));

        return Promise.all(promises);
      })
      .then(() => {
        // the /story/moments request is handled by the strategy StaleWhileRevalidate.
        // we want to revalidate the cache here but ignore the stale response.
        return storyService.getStoryMoments(storyId);
      })
  });
}

const uploadMoment = async (moment, file) => {
  return storyService.getMomentUploadUrl(moment.id, file.type)
    .then(resp => {
      storyService.uploadToStorage(resp.url, file)
    })
    .then(() => storyService.setMomentUploaded(moment.id))
}

const ensureMomentDimensions = async moments => {
  let promises = [];
  let needed = [];

  for (let moment of moments) {
    if (!moment.type || !moment.type.match(/video/) && (!moment.height || !moment.width)) {
      needed.push(moment);

      let promise = getImage(moment.preview_url);
      promises.push(promise);
    }
  }

  if (promises.length) {
    let images = await Promise.all(promises);

    for (let moment of needed) {
      for (let image of images) {
        if (image.src === moment.preview_url) {
          moment.width = image.width;
          moment.height = image.height;
          break;
        }
      }
    }
  }

  return moments;
}

const getImage = async url => {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = () => resolve(img);
    img.src = url;
  });
}
